import React from "react";

// reactstrap components
import { Button, Container } from "reactstrap";

function HeroComponent() {
  return (
    <div className="hero-container">
      <div className="hero-container-title">
        <h1>Simple Innovation to deliver perfection.</h1>
        <p>
          we make custom application solution to help your business with ignite
          of curiousity.
        </p>
      </div>
    </div>
  );
}

export default HeroComponent;
